import React, { useState } from "react";
import { SafeMarkdown } from "@/components/markdown/SafeMarkdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import {
  ChevronDown,
} from "lucide-react";

// Legacy UI for historical `meta_data.reasonings`. New answers do not persist this field.
const MessageReasoning = (props) => {
  const { message } = props;
  const [expandedMessageReasoning, setExpandedMessageReasoning] = useState(
    message.content.toLowerCase().includes("sorry") ? message.id : null,
  );
  const reasoningsText = Array.isArray(message.meta_data?.reasonings)
    ? message.meta_data?.reasonings.join(" ")
    : message.meta_data?.reasonings;

  const toggleExpansionReasoning = (id) => {
    if (expandedMessageReasoning === id) {
      setExpandedMessageReasoning(null);
    } else {
      setExpandedMessageReasoning(id);
    }
  };

  return (
    <>
      {message.meta_data?.reasonings && (
        <aside className="additional-info-dropdown mb-4">
          <div
            role="button"
            className="additional-info-dropdown-title mb-2"
            style={{ cursor: "pointer" }}
            onClick={() => toggleExpansionReasoning(message.id)}
            onKeyDown={(e) => (e.key === "Enter" ? toggleExpansionReasoning(message.id) : null)}
            tabIndex={0}
          >
            <div className="flex flex-row items-center">
              <p className="dropdown-secondary mr-2 font-semibold">Reasoning</p>
              <ChevronDown
                className={`secondary-dropdown-arrow max-h-4 content-center transform transition-transform duration-200 ${
                  expandedMessageReasoning === message.id ? "rotate-180" : "rotate-0"
                }`}
              />
            </div>
          </div>
          {expandedMessageReasoning === message.id && (
            <div className="p2 additional-info-content pt-2 border-t border-gray-300">
              <div className="chat-message-markdown">
                <SafeMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
                  {reasoningsText}
                </SafeMarkdown>
              </div>
            </div>
          )}
        </aside>
      )}
    </>
  );
};

export default MessageReasoning;
